import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TableModuleComponent} from "./table-module.component";
import {MainTitleModule} from "../main-title/main-title.module";
import {SafeHtmlModule} from "../../pipes/safe-html/safe-html.module";


@NgModule({
  declarations: [
    TableModuleComponent
  ],
  exports: [
    TableModuleComponent
  ],
  imports: [
    CommonModule,
    MainTitleModule,
    SafeHtmlModule
  ]
})
export class TableModuleModule {
}
